/* eslint-disable no-eval */
import BaseMiddleware from "src/middleware/BaseMiddleware";
import { types as authType } from "src/store/modules/Auth.module";
import store from "src/store";

class RoleMiddleware extends BaseMiddleware {
	static goToLogin (next) {
		return next({
			name: "error-page",
		});
	}

	async isConnected () {
		if (!store.getters.isConnected) {
			try {
				await store.dispatch(authType.GET);
				return store.getters.isConnected;
			} catch (e) {
				return false;
			}
		}
		return true;
	}

	async handle (next, to, from, args) {
		let canGoOn = false;
		if (await this.isConnected()) {
			const auth = store.state.AuthModule.user;
			const roleRoute = to.matched.find(m => m.meta.role !== undefined);
			const role = roleRoute.meta.role;
			if (typeof role === "object") {
				canGoOn = eval(`${auth.role} ${role.operator} ${role.role}`);
			} else if (typeof role === "function") {
				canGoOn = await role(auth);
			} else {
				canGoOn = (+auth.role === +role);
			}
		}
		return canGoOn ? next() : RoleMiddleware.goToLogin(next);
	}
}

export const rules = {};

export default RoleMiddleware;
